const actions = {
  fetchPending: 'LOADING::FIRE_ROLL_CALL',
  fetchFireRollCall: 'FETCH::FIRE_ROLL_CALL',
  setFireRollCall: 'SET::FIRE_ROLL_CALL',
  resetFireRollCall: 'RESET::FIRE_ROLL_CALL'
}

export const getFireRollCall = state => state.fireRollCall
export default actions



// WEBPACK FOOTER //
// ./src/store/fire-roll-call/actions.js